const columns = `id,org_id,job_id,title,source,due_date,completed,completed_at,created_at,sort_order,photo_r2_key,completed_photo_r2_key,
  job:t4s_jobs!job_id!inner(id,org_id,name,job_number),
  assigned:t4s_employees!assigned_to(display_name,first_name,last_name)`;

// Read the same records as Forward Command, with immutable cursors and company scoping.
export async function readPunchlist(client, orgId, jobId = null) {
  if (!orgId || orgId === 'all') throw new Error('Select one company to view its punch list.');
  const rows = [], seen = new Set();
  let cursor = null;
  for (;;) {
    let query = client.from('t4s_punchlist_items').select(columns)
      .eq('org_id', orgId).eq('job.org_id', orgId).order('id').limit(500);
    if (jobId) query = query.eq('job_id', jobId);
    if (cursor) query = query.gt('id', cursor);
    const { data, error } = await query;
    if (error) throw error;
    if (!Array.isArray(data)) throw new Error('Punch list response was incomplete.');
    for (const row of data) {
      if (!row.id || seen.has(row.id) || (cursor && row.id <= cursor)) throw new Error('Punch list changed while loading. Please refresh.');
      if (row.org_id !== orgId || row.job?.org_id !== orgId || row.job?.id !== row.job_id || (jobId && row.job_id !== jobId)) {
        throw new Error('Punch list company or job did not match. Please refresh.');
      }
      seen.add(row.id); rows.push(row);
    }
    if (data.length < 500) return rows;
    cursor = data[data.length - 1].id;
  }
}

export const punchlistPerson = person => person?.display_name || [person?.first_name, person?.last_name].filter(Boolean).join(' ');
export const punchlistSource = source => ({ walkthrough: 'Walkthrough', status: 'Job status', voice: 'Voice note', event: 'Event', manual: 'Added in field' })[source] || 'Field item';
export function punchlistDate(value) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return '';
  const date = new Date(`${value}T12:00:00`);
  return Number.isNaN(date.getTime()) ? '' : date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}
export function groupPunchlist(rows, status, search) {
  const needle = search.trim().toLowerCase();
  const matches = rows.filter(row => (status === 'all' || row.completed === (status === 'completed'))
    && `${row.title} ${row.job?.name || ''} ${row.job?.job_number || ''} ${punchlistPerson(row.assigned)}`.toLowerCase().includes(needle));
  const groups = new Map();
  for (const row of matches) {
    if (!groups.has(row.job_id)) groups.set(row.job_id, { job: row.job, items: [] });
    groups.get(row.job_id).items.push(row);
  }
  return [...groups.values()].sort((a, b) => (a.job?.name || '').localeCompare(b.job?.name || '')).map(group => ({ ...group,
    items: group.items.sort((a, b) => Number(a.completed) - Number(b.completed)
      || (a.due_date || '9999').localeCompare(b.due_date || '9999')
      || (a.sort_order || 0) - (b.sort_order || 0) || (b.created_at || '').localeCompare(a.created_at || '') || a.id.localeCompare(b.id)),
  }));
}
